import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { CypressTestId } from '@/modules/cypress/components/cypress-test-id/CypressTestId'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type LoginModalProps = InheritableModalProps & {
  onAction: () => void
}

export const LogoutModal = ({ onAction, ...props }: LoginModalProps) => {
  const theme = useTheme()

  return (
    <Modal {...props}>
      <CypressTestId id='log-out-modal'>
        <FlexColumn alignContent='center'>
          <FontAwesomeIcon icon={['fal', 'question-circle']} fontSize={24} />

          <Margin mt={theme.UI.Spacing.Space5} />

          <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
            {t({ id: 'logout.title', message: 'Afmelden' })}
          </H3>

          <P type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
            {t({
              id: 'logout.body1',
              message: 'Ben je zeker dat je je wil afmelden?',
            })}
            <br />
            {t({
              id: 'logout.body2',
              message:
                'Na het afmelden vraagt eHealth je om ook daar af te melden. Bevestig dit om je persoonlijke gegevens te beschermen.',
            })}
          </P>

          <CypressTestId id='log-out-confirm-button'>
            <Button variant='Primary' onClick={onAction}>
              {t({
                id: 'logout.confirm',
                message: 'Nu afmelden',
              })}
            </Button>
          </CypressTestId>
          <Margin mt={theme.UI.Spacing.Space2} />
          <CypressTestId id='log-out-cancel-button'>
            <Button variant='Tertiary' onClick={props.onClose}>
              {t({
                id: 'logout.cancel',
                message: 'Annuleren',
              })}
            </Button>
          </CypressTestId>
        </FlexColumn>
      </CypressTestId>
    </Modal>
  )
}
